/* eslint-disable import/default */

// FontAwesome 5 - https://fontawesome.com/
import '@fortawesome/fontawesome-free/css/all.css';
import 'slick-carousel/slick/slick.scss';
import 'slick-carousel/slick/slick-theme.scss';
import 'lightgallery/src/sass/lightgallery.scss';
import {
    jarallax,
    jarallaxVideo
} from "jarallax";
import 'bootstrap';
import 'slick-carousel';

import sidebarNav from './header/sidebar-nav';
import searchControls from './header/search';

import CasketDesign from './casketdesign';
import MusicPlaylist from './playlists';
import VehicleMileage from './vehicle-mileage/vehicle-mileage';

import inView from 'in-view';

import 'lightgallery';
import 'lg-thumbnail';
import 'lg-video';
import Masonry from 'masonry-layout';

$(function () {

    setTimeout(function(){
        $('.SignInPage .alert').addClass('d-none');
        $('.video-background').addClass('d-none');
    }, 5000);


    const $body = $('body');

    if ($('.section.casket-design').length) {
        new CasketDesign('.section.casket-design', true).init();
    }

    if ($('.section.playlist').length) {
        new MusicPlaylist().init();
    }

    if (!detectIE()) {
        $('.parallax').jarallax({
            speed: 0.8,
            disableParallax: function () {
                var isEdge = /Edge\/\d+/.test(navigator.userAgent);
                var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
                if(isEdge){
                    return true;
                }
                if(isSafari){
                    return true;
                }
                return /iPad|iPhone|iPod|Android/.test(navigator.userAgent);
            }
            /*disableParallax: /iPad|iPhone|iPod|Android/,
            disableVideo: /iPad|iPhone|iPod|Android/*/
        });
    }

    sidebarNav();
    searchControls();
    VehicleMileage();

    $('.lightgallery').lightGallery({
        selector: '.lightgallery-item',
        thumbnail: true
    });


    $('.info-slider-element .info-slider-images').slick({
        autoplay: true,
        arrows: true,
        dots: true
    });

    if ($('.tribute-message-container').length > 0) {
        const masonry_container = document.querySelector('.tribute-message-container');
        new Masonry(masonry_container, {
            itemSelector: '.tribute-message-item'
        });
    }

    if ($('.tribute-family-message-container').length > 0) {
        const masonry_container = document.querySelector('.tribute-family-message-container');
        new Masonry(masonry_container, {
            itemSelector: '.tribute-message-item'
        });
    }

    $('#headstones-granite').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        asNavFor: '#headstones-granite-nav'
    });

    $('#headstones-granite-nav').slick({
        slidesToShow: 5,
        slidesToScroll: 1,
        arrows: false,
        asNavFor: '#headstones-granite',
        dots: false,
        centerMode: false,
        focusOnSelect: true
    });

    $('#headstones-designs').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        asNavFor: '#headstones-designs-nav'
    });

    $('#headstones-designs-nav').slick({
        slidesToShow: 5,
        slidesToScroll: 1,
        arrows: false,
        asNavFor: '#headstones-designs',
        dots: false,
        centerMode: false,
        focusOnSelect: true
    });

    $('.headstones-images-nav-slide-image[data-toggle="tooltip"]').tooltip();

    $('.tribute-detail-images').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        asNavFor: '.tribute-detail-images-nav'
    });

    $('.tribute-detail-images-nav').slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: false,
        asNavFor: '.tribute-detail-images',
        dots: false,
        centerMode: false,
        focusOnSelect: true
    });


    $body.on('click', '.tribute-pagination .page-link', function(e) {
        e.preventDefault();

        const $this = $(this),
              $tributes = $('.tribute-list'),
              url = $this.attr('href');

        $.ajax({
            url,
            beforeSend: function(){
                $this.data('original-text', $this.html());
                $this.width($this.width());
                $this.attr('disabled', true);
                $this.html('<i class="fas fa-circle-notch fa-spin"></i>');
            },
            success: function(data){
                const html = $(data).find('.tribute-list').html();
                $tributes.html(html);
                history.pushState(null, null, url);
            }
        }).always(function() {
            $this.html($this.data('original-text'));
            $this.attr('disabled', false);
            $('html, body').animate({
                scrollTop: $('.tributes').offset().top
            }, 500);
        });
    });

    $body.on('click', '.tribute-search button[type=submit]', function(e) {
        e.preventDefault();

        const $tributes = $('.tribute-list'),
              $input = $('.tribute-search input[type=text]'),
              $button = $('.tribute-search button'),
              search_term = $input.val(),
              search_name = $input.attr('name'),
              url = search_term !== '' ? `${location.pathname}?${search_name}=${search_term}` : location.pathname;

        $.ajax({
            url,
            beforeSend: function(){
                $button.data('original-text', $button.html());
                $button.width($button.width());
                $button.attr('disabled', true);
                $button.html('<i class="fas fa-circle-notch fa-spin"></i>');
            },
            success: function(data){
                const html = $(data).find('.tribute-list').html();
                $tributes.html(html);
                history.pushState(null, null, url);
            }
        }).always(function() {
            $button.html($button.data('original-text'));
            $button.attr('disabled', false);
        });
    });


    if (!detectIE()) {
        inView('.img-lazy[data-lazy]')
            .on('enter', element => {
                if (!$(element).hasClass('loaded')) {
                    lazyLoad(element);
                }
            });
        inView.offset(-200);
    } else {
        $('.img-lazy[data-lazy]').each(function(){
            lazyLoad(this);
        });
    }


    if ($('title').text().indexOf('Cemeteries') !== -1) {

        let nav = '';
        const titles = {};

        $('.element').each(function(){
            const key = $(this).find('h2').text().substring(0, 1);

            if (!titles.hasOwnProperty(key)) {
                titles[key] = '#' + $(this).attr('id');
            }
        });

        for (let i = 65; i <= 90; i++) {
            const letter = String.fromCharCode(i);

            if (titles.hasOwnProperty(letter)) {
                nav += `<a href="${titles[letter]}" class="nav-letter">${letter}</a>`;
            } else {
                nav += `<span class="nav-letter">${letter}</span>`;
            }
        }

        nav = `<ul class="nav nav-pills">${nav}</ul>`;

        $('.section-element').find("[class*='col']").not('.elemental-columns-image').each(function(){
            $(this).html($(this).html() + '<p><a href="#letters-nav">Back to top</a></p>');
        });

        $('.section-element:eq(0)').before(
            `<div class="section section-element" id="letters-nav">
                <div class="container">
                    <div class="nav-letters">${nav}</div>
                </div>
            </div>`);

    }

    if($('#ShowPopupAlert').length > 0){
        $('#ShowPopupAlert').modal('show');
    }

});

function lazyLoad(element) {
    let lazy = $(element).data('lazy');
    let img = new Image();
    img.onload = function() {
        $(element).attr('src', this.src);
        setTimeout(()=>{
            $(element).addClass('loaded');
        }, 1);
    };
    img.src = lazy;
}

function detectIE() {
    const ua = window.navigator.userAgent,
          msie = ua.indexOf('MSIE '),
          trident = ua.indexOf('Trident/');

    if (msie > 0) {
        // IE 10 or older => return version number
        return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
    }

    if (trident > 0) {
        // IE 11 => return version number
        const rv = ua.indexOf('rv:');
        return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
    }

    // other browser
    return false;
}
